import React, { Fragment, useContext, useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { EXPENSE_STATUS_ID, roles } from "../../../configs/constants";
import { ExpenseReportsContext } from "./../expenseReports/ExpenseReportsContext";
import Modal from "../../../components/modalComponent/ModalComponent";

import { startOfWeek } from "./../expenseReports/ExpenseReports.utils";
import DisplayAttachments from "./DisplayAttachments.modal";
import ExpenseReportModal from "./ExpenseReportModal";
import ExpenseForm from "./Expense.form";
import ModalComponent from "../../../components/modalComponent/ModalComponent";
import { Dropdown, Menu, Modal as ModalAntd } from "antd";
import { get } from "../utils/utils";

const baseapi = process.env.REACT_APP_API + "/api";

export const ListMealPackages = ({ expenseReport, token }) => {
  const [dates, setDates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const fetchDatesOfMealPackages = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/mealpackages`,
        {
          match: { "meal_package._id": expenseReport.ref_ids },
          project: { date: 1 }
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setDates(result.data.map(d => d.date));
    } catch (e) {
      console.log(e);
    }

    setIsLoading(false);
  };
  useEffect(() => {
    fetchDatesOfMealPackages();
  }, []);
  if (isLoading) return <div>...</div>;
  return (
    <div>
      {dates.map(date => (
        <div>{moment(date).format("DD-MM-YYYY")}</div>
      ))}
    </div>
  );
};
const UserExpenseRowRow = ({ expenseReport, getRangeRequestParams, getMatchParams, currentPage }) => {
  const {
    setWeekDate,
    handleOnClickDetailsView,
    setIsDetailsViewActive,
    setSelectedRequest,
    fetchExpenseReportsList,
    requestFetchExpenseReportList,
    setModalOpen,
    rangeDate,
    setModalType,
    fetchUsersSectors,
    userRoleId,
    userId,
    userEmail,
    token
  } = useContext(ExpenseReportsContext);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalPJVisible, setIsModalPJVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [expenseToModify, setExpenseToModify] = useState(null);
  const [isFormModifyExpenseVisible, setIsFormModifyExpenseVisible] = useState(false);
  const manangeButtonPressed = ({ expenseReport, modalType }) => {
    setSelectedRequest(expenseReport);
    // setModalType(modalType);
    // setModalOpen(true);
  };

  const getModalTitle = typeName => {
    if (userRoleId === 3) setModalTitle("Qualification manager");
    else if (userRoleId === 2) setModalTitle("Validation comptable");
    else setModalTitle(`Note de frais : ${typeName}`);
  };
  const status = expenseReport.status || {};

  const isToBeTreatedBtnDisplayed = () => {
    if (status.id === EXPENSE_STATUS_ID.PENDING && userRoleId <= roles.MANAGER) return true;
    else if (status.id === EXPENSE_STATUS_ID.PREVALIDATED && userRoleId <= roles.DIRECTOR) return true;
    return false;
  };

  const isModifyBtnDisplayed = () => {
    if (expenseReport.type && expenseReport.type["CRÉDIT"]) {
      return false;
    }
    if (
      userRoleId === roles.TERRAIN &&
      expenseReport.status.id === EXPENSE_STATUS_ID.PENDING &&
      userEmail === expenseReport.user_email
    ) {
      return true;
    }
    if (
      userRoleId <= roles.MANAGER &&
      (expenseReport.status.id === EXPENSE_STATUS_ID.PENDING ||
        expenseReport.status.id === EXPENSE_STATUS_ID.PREVALIDATED ||
        expenseReport.status.id === EXPENSE_STATUS_ID.REFUSED)
    ) {
      return true;
    }

    return false;
  };
  const rejectedComment = get(["rejected_infos", "comment"], expenseReport, "non renseigné");
  const rejectedType = get(["rejected_infos", "type", "label"], expenseReport, "");
  const refusedComment = get(["refused_infos", "comment"], expenseReport, "non renseigné");
  const refusedType = get(["refused_infos", "type", "label"], expenseReport, "");

  return (
    <tr className="hover:bg-gray-100 cursor-pointer" key={expenseReport._id}>
      <td className="p-2 py-4  border-b border-gray-200 text-md leading-5 text-gray-900">
        <div className="flex items-center justify-between ">
          <div>S{moment(expenseReport.date).isoWeek()}</div>
          <div className="flex items-center justify-between">
            <button
              className="mr-2"
              onClick={() => {
                setWeekDate(startOfWeek(expenseReport.date));
                handleOnClickDetailsView({
                  match: {
                    email: expenseReport.user_email
                  },
                  start_date: moment(expenseReport.date).format("YYYY-MM-DD")
                });
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 84.064 91.561">
                <g id="planning-orange" transform="translate(-203.035 -754.845)">
                  <g stroke="white" id="Groupe_357" data-name="Groupe 357" transform="translate(-1 -1)">
                    <path
                      id="calendar"
                      d="M13.3,95.694v-65.4a6.567,6.567,0,0,1,1.911-4.629,6,6,0,0,1,4.556-1.911h6.467V18.83a8.1,8.1,0,0,1,2.351-5.805A7.72,7.72,0,0,1,34.316,10.6H37.55a8.155,8.155,0,0,1,8.083,8.23v4.923h19.4V18.83a8.1,8.1,0,0,1,2.351-5.805A7.72,7.72,0,0,1,73.116,10.6h3.233a8.155,8.155,0,0,1,8.083,8.23v4.923H90.9a6.524,6.524,0,0,1,6.467,6.54V95.621a6.567,6.567,0,0,1-1.911,4.629,6,6,0,0,1-4.556,1.911H19.767A6.524,6.524,0,0,1,13.3,95.694Zm6.467,0H90.9V43.374H19.767ZM32.7,33.6a1.669,1.669,0,0,0,.441,1.176,1.551,1.551,0,0,0,1.176.441H37.55a1.669,1.669,0,0,0,1.176-.441,1.551,1.551,0,0,0,.441-1.176V18.9a1.669,1.669,0,0,0-.441-1.176,1.551,1.551,0,0,0-1.176-.441H34.316A1.517,1.517,0,0,0,32.7,18.9Zm38.8,0a1.669,1.669,0,0,0,.441,1.176,1.551,1.551,0,0,0,1.176.441h3.233a1.669,1.669,0,0,0,1.176-.441,1.551,1.551,0,0,0,.441-1.176V18.9a1.669,1.669,0,0,0-.441-1.176,1.551,1.551,0,0,0-1.176-.441H73.116A1.517,1.517,0,0,0,71.5,18.9Z"
                      transform="translate(190.734 745.245)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_231"
                      data-name="Rectangle 231"
                      width="7.974"
                      height="7.974"
                      transform="translate(218.389 797.561)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_238"
                      data-name="Rectangle 238"
                      width="7.974"
                      height="7.974"
                      transform="translate(218.389 811.664)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_242"
                      data-name="Rectangle 242"
                      width="7.974"
                      height="7.974"
                      transform="translate(218.389 826.268)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_233"
                      data-name="Rectangle 233"
                      width="7.974"
                      height="7.974"
                      transform="translate(250.285 797.561)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_235"
                      data-name="Rectangle 235"
                      width="7.974"
                      height="7.974"
                      transform="translate(250.285 811.664)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_239"
                      data-name="Rectangle 239"
                      width="7.974"
                      height="7.974"
                      transform="translate(250.285 826.268)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_232"
                      data-name="Rectangle 232"
                      width="7.974"
                      height="7.974"
                      transform="translate(234.336 797.561)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_237"
                      data-name="Rectangle 237"
                      width="7.974"
                      height="7.974"
                      transform="translate(234.336 811.664)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_241"
                      data-name="Rectangle 241"
                      width="7.974"
                      height="7.974"
                      transform="translate(234.336 826.268)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_234"
                      data-name="Rectangle 234"
                      width="7.974"
                      height="7.974"
                      transform="translate(266.232 797.561)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_236"
                      data-name="Rectangle 236"
                      width="7.974"
                      height="7.974"
                      transform="translate(266.232 811.664)"
                      fill="#ff5200"
                    />
                    <rect
                      id="Rectangle_240"
                      data-name="Rectangle 240"
                      width="7.974"
                      height="7.974"
                      transform="translate(266.232 826.268)"
                      fill="#ff5200"
                    />
                  </g>
                </g>
              </svg>
            </button>
          </div>
        </div>
      </td>
      <td className="p-2 py-4  border-b border-gray-200 text-md leading-5 text-gray-900">
        {expenseReport.user_fullname}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 text-md leading-5 text-gray-900">
        {expenseReport.created_by && expenseReport.created_by.user_fullname}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 text-md leading-5 text-gray-900">
        {expenseReport.type && expenseReport.type.def}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-500">
        {status.id === EXPENSE_STATUS_ID.PENDING && (
          <span className="px-3 py-1 text-sm leading-5 font-medium rounded-full bg-gray-200 text-gray-800">
            {expenseReport.status.label}
          </span>
        )}
        {expenseReport.status && status.id === EXPENSE_STATUS_ID.PREVALIDATED && (
          <span className="font-bold text-green-500">
            Acceptée
            {/*TODO: change later when back will replaced prévalidee by acceptee*/}
            {/*{expenseReport.status.label}*/}
          </span>
        )}
        {expenseReport.status && (expenseReport.status.id === 6 || expenseReport.status.id === 5) && (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item>{rejectedComment}</Menu.Item>
                <Menu.Item>{rejectedType}</Menu.Item>
              </Menu>
            }
          >
            <span className="font-bold text-red-500">{expenseReport.status.label}</span>
          </Dropdown>
        )}
        {expenseReport.status && expenseReport.status.id === 4 && (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item>{refusedComment}</Menu.Item>
                <Menu.Item>{refusedType}</Menu.Item>
              </Menu>
            }
          >
            <span className="font-bold text-purple-400">{expenseReport.status.label}</span>
          </Dropdown>
        )}
        {expenseReport.status && status.id === EXPENSE_STATUS_ID.VALIDATED && (
          <span className="font-bold text-blue-500">{expenseReport.status.label}</span>
        )}
        {expenseReport.status && status.id === EXPENSE_STATUS_ID.REFUND && (
          <span className="font-bold text-yellow-300">{expenseReport.status.label}</span>
        )}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-900">
        {moment(expenseReport.created_at).format("dddd")} {moment(expenseReport.created_at).format("DD/MM/YYYY")}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-900">
        {moment(expenseReport.date).format("dddd")} {moment(expenseReport.date).format("DD/MM/YYYY")}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-900">
        {expenseReport.price
          ? expenseReport.price && Number.parseFloat(expenseReport.price).toFixed(2)
          : expenseReport.calculatedPrice
          ? Number.parseFloat(expenseReport.calculatedPrice).toFixed(2)
          : "N/C"}
        {(expenseReport.price || expenseReport.calculatedPrice) && "€"}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-900">
        {/*{expenseReport.type && expenseReport.type["politique interne UP SELL"]}*/}
        {Array.isArray(expenseReport.ref_ids) &&
          expenseReport.ref_ids.length > 0 &&
          expenseReport.type &&
          expenseReport.type.def === "Repas CS / CDV" && (
            <Fragment>
              <ListMealPackages expenseReport={expenseReport} token={token} />
            </Fragment>
          )}
        {Array.isArray(expenseReport.extra_fields) && expenseReport.extra_fields.length > 0 && (
          <Fragment>
            {expenseReport.extra_fields.map(ef => {
              return <span key={ef.id}>{`${ef.value} L`}</span>;
            })}
          </Fragment>
        )}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-900">
        {Array.isArray(expenseReport.attachements) && expenseReport.attachements.length > 0 && (
          <a className="cursor-pointer underline font-bold text-orange-400" onClick={() => setIsModalPJVisible(true)}>
            Voir
          </a>
        )}
        <Modal title="Pièces jointes" showModal={isModalPJVisible} closeModal={() => setIsModalPJVisible(false)}>
          <DisplayAttachments attachments={expenseReport.attachements} closeModal={() => setIsModalPJVisible(false)} />
        </Modal>
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-900">
        {expenseReport.status &&
          (status.id === EXPENSE_STATUS_ID.PENDING ? (
            "Non Traité"
          ) : (
            <div>
              {moment(expenseReport.status.updated_at || expenseReport.created_at).format("dddd")}{" "}
              {moment(expenseReport.status.updated_at || expenseReport.created_at).format("DD/MM/YYYY")}
            </div>
          ))}
      </td>
      <td className="p-2 py-4  border-b border-gray-200 leading-5 text-gray-900">
        <a
          className="flex cursor-pointer underline font-bold text-orange-400"
          onClick={() => {
            getModalTitle(expenseReport.type && expenseReport.type.type);
            setIsModalVisible(true);
          }}
        >
          Voir
          {/*{isToBeTreatedBtnDisplayed() ? "A traiter" : "Voir"}*/}
        </a>
        {isModifyBtnDisplayed() && (
          <a
            className="flex mt-2 cursor-pointer underline font-bold text-orange-400"
            onClick={() => {
              setExpenseToModify(expenseReport);
              setIsFormModifyExpenseVisible(true);
            }}
          >
            {isModifyBtnDisplayed() && "Modifier"}
          </a>
        )}
        {(userRoleId === roles.DIRECTOR || userRoleId === roles.ADMIN) &&
          (expenseReport.status.id === EXPENSE_STATUS_ID.VALIDATED ||
            expenseReport.status.id === EXPENSE_STATUS_ID.REJECTED) && (
            <a
              className="flex mt-2 cursor-pointer underline font-bold text-orange-400"
              onClick={() => {
                ModalAntd.confirm({
                  title: 'Repasser en "acceptée"?',
                  content: `Dans le cas où une note de frais a été validée ou rejetée par erreur,  vous pouvez faire repasser le statut de la note de frais en "acceptée".
                  Voulez-vous repasser le statut de la note de frais en "acceptée"?`,
                  okText: "Oui",
                  cancelText: "Non",
                  onOk() {
                    axios
                      .post(`${baseapi}/expense/backtoprevalidate`, expenseReport, {
                        headers: {
                          Authorization: token
                        }
                      })
                      .then(() => {
                        requestFetchExpenseReportList({
                          page: currentPage,
                          match: { ...getMatchParams(), ...getRangeRequestParams(rangeDate).match }
                        });
                      })
                      .catch(e => {
                        console.log(e);
                      });
                  }
                });
              }}
            >
              Repasser en "acceptée"
            </a>
          )}
        {(userRoleId === roles.DIRECTOR || userRoleId === roles.ADMIN) &&
          (expenseReport.status.id === EXPENSE_STATUS_ID.PREVALIDATED ||
            expenseReport.status.id === EXPENSE_STATUS_ID.REFUSED) && (
            <a
              className="flex mt-2 cursor-pointer underline font-bold text-orange-400"
              onClick={() => {
                ModalAntd.confirm({
                  title: 'Repasser à "En attente de traitement"?',
                  content: `Dans le cas où une note de frais a été acceptée ou refusée par erreur,  vous pouvez faire repasser le statut de la note de frais à "En attente de traitement".
                  Voulez vous continuer?`,
                  okText: "Oui",
                  cancelText: "Non",
                  onOk() {
                    axios
                      .post(`${baseapi}/expense/backtopending`, expenseReport, {
                        headers: {
                          Authorization: token
                        }
                      })
                      .then(() => {
                        requestFetchExpenseReportList({
                          page: currentPage,
                          match: { ...getMatchParams(), ...getRangeRequestParams(rangeDate).match }
                        });
                      })
                      .catch(e => {
                        console.log(e);
                      });
                  }
                });
              }}
            >
              Repasser à "en attente de traitement"
            </a>
          )}
        <Modal width="651px" title={modalTitle} showModal={isModalVisible} closeModal={() => setIsModalVisible(false)}>
          <ExpenseReportModal
            view="list"
            userId={userId}
            userRoleId={userRoleId}
            expensesTab={[expenseReport]}
            isModalVisible={isModalVisible}
            closeModal={() => setIsModalVisible(false)}
            requestToTriggered={() =>
              requestFetchExpenseReportList({
                page: currentPage,
                match: { ...getMatchParams(), ...getRangeRequestParams(rangeDate).match }
              })
            }
          />
        </Modal>
        <ModalComponent
          title={`Modification d'une note de frais`}
          width={700}
          showModal={isFormModifyExpenseVisible}
          closeModal={() => setIsFormModifyExpenseVisible(false)}
        >
          <ExpenseForm
            fetchUsersSectors={fetchUsersSectors}
            expenseToModify={expenseToModify}
            closeModal={() => setIsFormModifyExpenseVisible(false)}
            token={token}
            requestFetch={requestFetchExpenseReportList}
          />
        </ModalComponent>
      </td>
    </tr>
  );
};

export default UserExpenseRowRow;



// WEBPACK FOOTER //
// src/modules/presence/components/UserExpenseReportRow.js